// Organizations
var org =  {
  CHEVRON: "Chevron",
  LR: "LR"
};

var date_format_mmddyy = [
  "Visit Date"
];
